var $0b59913724901541$exports = {};
$0b59913724901541$exports = {
    "info": `Informaci\xf3n`,
    "negative": `Error`,
    "positive": `\xc9xito`
};


export {$0b59913724901541$exports as default};
//# sourceMappingURL=es-ES.mjs.map
